import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { Grid, Stack } from "@mui/system";
import { MdsIcon, useMuiController } from "@sinch/components";
import { useMessageChannels } from "@sinch/components/application/Messages/useMessageChannels";
import { MessageFormFields } from "@sinch/components/application/Messages/MessageForm/formSchema";

/**
 * Component for selecting a message channel.
 *
 * This component renders a set of buttons corresponding to the allowed channels.
 * Each button displays an icon and label for the channel, and clicking the button
 * updates the selected channel using the provided form field controller.
 */
export const ChannelSelect = () => {
  const { getChannelIcon, getChannelLabel, getChannelList } = useMessageChannels();

  const { field } = useMuiController<MessageFormFields, "channels">({
    name: "channels",
  });

  return (
    <Grid
      alignItems="stretch"
      container
      justifyContent="center"
      spacing={2}
      sx={{ px: { xs: 0, sm: 3 }, pb: 4 }}
      wrap="nowrap"
    >
      {getChannelList().map((channel) => (
        <Grid key={channel} size={4}>
          <Button
            fullWidth
            onClick={() => field.onChange([channel])}
            sx={{ py: { xs: 1, sm: 3 }, height: "100%" }}
            variant={field.value.includes(channel) ? "contained" : "outlined"}
          >
            <Stack alignItems="center" direction="column" flexWrap="wrap" spacing={1}>
              <MdsIcon
                fontSize="large"
                icon={getChannelIcon(channel)}
                sx={({ typography }) => ({ fontSize: { xs: typography.pxToRem(24), sm: typography.pxToRem(35) } })}
              />
              <Typography
                sx={({ typography }) => ({ fontSize: { xs: typography.pxToRem(12), sm: typography.pxToRem(17) } })}
                variant="h6"
              >
                {getChannelLabel(channel)}
              </Typography>
            </Stack>
          </Button>
        </Grid>
      ))}
    </Grid>
  );
};
